var _rect, _rect2, _rect3, _rect4, _rect5, _g, _rect6, _g2, _rect7, _g3, _g4, _g5, _g6, _rect8, _rect9, _rect10, _mask, _rect11, _mask2, _rect12, _mask3, _rect13, _circle, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRipeningOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.669922,
    y: 0.49292,
    width: 68.5548,
    height: 68.5548,
    rx: 9.79354,
    fill: "#FFE5DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6188,
    y: 23.495,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5573,
    y: 31.8366,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4108,
    y: 40.1793,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8932,
    y: 23.4953,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3515 24.6914C20.1023 24.4411 20.0119 25.0737 19.8729 25.4213C19.8207 25.682 19.8729 26.0469 19.9771 26.3597C19.6852 26.9437 19.3515 26.6725 19.2472 26.4119C18.8302 25.9948 19.0387 24.9521 19.3515 24.6914Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0397,
    y: 31.8366,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.498 33.0342C21.2487 32.7839 21.1584 33.4165 21.0193 33.7641C20.9672 34.0247 21.0193 34.3897 21.1236 34.7025C20.8317 35.2864 20.498 35.0153 20.3937 34.7546C19.9766 34.3376 20.1852 33.2948 20.498 33.0342Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8932,
    y: 40.1793,
    width: 11.8834,
    height: 4.37578,
    rx: 2.18789,
    fill: "#ED5E2A",
    stroke: "#ED5E2A",
    strokeWidth: 0.212194
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3515 41.3767C20.1023 41.1264 20.0119 41.759 19.8729 42.1066C19.8207 42.3673 19.8729 42.7322 19.9771 43.045C19.6852 43.629 19.3515 43.3578 19.2472 43.0972C18.8302 42.6801 19.0387 41.6374 19.3515 41.3767Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0771 24.6929C37.8278 24.4426 37.7375 25.0752 37.5984 25.4228C37.5463 25.6834 37.5984 26.0484 37.7027 26.3612C37.4108 26.9451 37.0771 26.674 36.9728 26.4133C36.5557 25.9962 36.7643 24.9535 37.0771 24.6929Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0156 33.0356C38.7663 32.7854 38.6759 33.418 38.5369 33.7655C38.4848 34.0262 38.5369 34.3912 38.6412 34.704C38.3492 35.2879 38.0156 35.0168 37.9113 34.7561C37.4942 34.339 37.7028 33.2963 38.0156 33.0356Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_863_25467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3105 41.6948C38.0612 41.4446 37.9709 42.0771 37.8318 42.4247C37.7797 42.6854 37.8318 43.0503 37.9361 43.3631C37.6442 43.9471 37.3105 43.676 37.2062 43.4153C36.7891 42.9982 36.9977 41.9555 37.3105 41.6948Z",
    fill: "white"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9531,
    y: 28.2903,
    width: 32.95,
    height: 2.6068,
    fill: "#ED5E2A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9531,
    y: 36.4236,
    width: 32.95,
    height: 2.6068,
    fill: "#ED5E2A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9531,
    y: 44.8694,
    width: 32.95,
    height: 2.6068,
    fill: "#ED5E2A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-1_863_25467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4502,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4502,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 2.50253,
    mask: "url(#path-17-inside-1_863_25467)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-2_863_25467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.1768,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1768,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 2.50253,
    mask: "url(#path-18-inside-2_863_25467)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-3_863_25467",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.9023,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9023,
    y: 20.262,
    width: 2.50253,
    height: 31.1773,
    rx: 1.06097,
    fill: "white",
    stroke: "#ED5E2A",
    strokeWidth: 2.50253,
    mask: "url(#path-19-inside-3_863_25467)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.509,
    cy: 15.6213,
    r: 6.62127,
    fill: "#ED5E2A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2471,
    y: 12.3074,
    width: 0.938448,
    height: 4.85802,
    rx: 0.469224,
    transform: "rotate(-47.8638 37.2471 12.3074)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 45.0371,
    y: 12.8577,
    width: 0.938448,
    height: 4.56956,
    rx: 0.469224,
    transform: "rotate(58.4149 45.0371 12.8577)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7559,
    y: 15.1604,
    width: 0.938448,
    height: 2.22944,
    rx: 0.469224,
    transform: "rotate(90.2232 47.7559 15.1604)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6426,
    y: 15.1609,
    width: 0.938448,
    height: 2.22944,
    rx: 0.469224,
    transform: "rotate(90.2232 37.6426 15.1609)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9775,
    y: 21.6838,
    width: 0.938448,
    height: 2.22944,
    rx: 0.469224,
    transform: "rotate(-178.263 41.9775 21.6838)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9775,
    y: 11.7783,
    width: 0.938448,
    height: 2.22944,
    rx: 0.469224,
    transform: "rotate(-178.263 41.9775 11.7783)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5605,
    cy: 15.5691,
    r: 0.938448,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_863_25467",
    x: 18.1649,
    y: 24.6343,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_863_25467",
    x: 19.3114,
    y: 32.9771,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_863_25467",
    x: 18.1649,
    y: 41.3196,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_863_25467",
    x: 35.8905,
    y: 24.6357,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_863_25467",
    x: 36.829,
    y: 32.9785,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_863_25467",
    x: 36.1239,
    y: 41.6377,
    width: 2.66142,
    height: 3.77079,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.848774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.424387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_863_25467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_863_25467",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipeningOrange);
export default __webpack_public_path__ + "static/media/ripening_orange.a410baefdcefd229b4cd964158e53027.svg";
export { ForwardRef as ReactComponent };